import React, { createContext, useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

import { AppContextProps } from "../../Context/AppContext";
import { Endpoints } from "../../Lib/endpoints";
import { NonPaginatedResponse } from "../../Lib/responses";

import { usePerformRequest } from "../../Lib/usePerformRequest";

import {
  AdminProfileProps,
  AdminScopeObjectProps,
  AdminScopeValueProps,
} from "../../Lib/types";
import Team from "../Team";
import "./styles.scss";
import Overview from "../Overview";
import Navbar from "../../Components/Navbar";
import Plans from "../Plans";
import Courses from "../Courses";
import SingleCourse from "../SingleCourse";
import Teachers from "../Teachers";
import Blogs from "../Blogs";
import SingleBlogEdit from "../SingleBlog/Edit";
import SingleBlogView from "../SingleBlog/View";
import Students from "../Students";
import Transactions from "../Transactions";
import Waitlist from "../Waitlist";
import PageEditor from "../PageEditor";
import { RouteList } from "../../Lib/routes";
import Unauthorized from "../Unauthorized";
import SingleStudent from "../SingleStudent";
import SingleLessonLiveKit from "../SingleLessonLiveKit";
export const AppContext = createContext<AppContextProps | undefined>(undefined);

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const {
    data: adminProfile,
    response: adminProfileResponse,
    reloadData: reloadAdminProfile,
    isLoading: isLoadingProfile,
  } = usePerformRequest<NonPaginatedResponse<AdminProfileProps>>({
    method: Endpoints.GetAdminProfile().method,
    route: Endpoints.GetAdminProfile().route,
  });
  const {
    data: adminScopes,
    response: adminScopesResponse,
    reloadData: reloadAdminScopes,
    isLoading: isLoadingAdminScopes,
  } = usePerformRequest<NonPaginatedResponse<AdminScopeObjectProps[]>>({
    method: Endpoints.GetAdminScopes().method,
    route: Endpoints.GetAdminScopes().route,
  });

  useEffect(() => {
    if (adminProfileResponse && adminProfileResponse.status) {
      if (adminProfileResponse.status !== 200) {
        navigate("/login");
      }
    }
  }, [isLoadingProfile, adminProfileResponse]);

  const LogoutAdmin = async () => {
    localStorage.removeItem("t");
    navigate("/login");
  };

  const location = useLocation();
  const [isUnauthorized, setUnauthorized] = useState(false);
  useEffect(() => {
    // CHECK IF THE USER HAS ACCESS TO THE CURRENT ROUTE
    const currentRoute = RouteList.find(
      (route) => route.path === location.pathname
    );
    if (adminProfile?.data?.role === "admin") {
      if (currentRoute) {
        if (
          !currentRoute.scopes.some((scope) =>
            adminProfile?.data?.scopes.includes(scope)
          )
        ) {
          setUnauthorized(true);
          // navigate("/d");
        }
      }
    }
  }, [location]);
  return (
    <AppContext.Provider
      value={{
        logout: LogoutAdmin,
        profile: adminProfile?.data,
        isLoadingProfile,
        reloadProfile: reloadAdminProfile,
        scopes: adminScopes?.data ?? [],
      }}
    >
      <div className="dashboard-container">
        <Navbar />
        {isUnauthorized && <Unauthorized />}
        <Routes>
          <Route path="/" element={<Overview />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/team" element={<Team />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/courses" element={<Courses />} />
          <Route
            path="/room/:lessonID/:batchID"
            element={<SingleLessonLiveKit />}
          />
          <Route path="/course/:courseID" element={<SingleCourse />} />
          <Route path="/teachers" element={<Teachers />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog-edit/:blogID" element={<SingleBlogEdit />} />
          <Route path="/blog-view/:blogID" element={<SingleBlogView />} />
          <Route path="/students" element={<Students />} />
          <Route path="/waitlist" element={<Waitlist />} />
          <Route path="/page-editor" element={<PageEditor />} />
          <Route path="/student/:studentID" element={<SingleStudent />} />
          <Route path="/billing" element={<Transactions />} />
        </Routes>
      </div>
    </AppContext.Provider>
  );
};
export default Dashboard;
